import React from 'react';
import Header from '@/features/facility/welcome/components/Header';
import Main from '../components/Main';
import Footer from '@/features/facility/welcome/components/Footer';

const ForgotPassowrd = () => {
  return (
    <React.Fragment>
      <Header />
      <Main />
      <Footer />
    </React.Fragment>
  );
};

export default ForgotPassowrd;